import { readBooleanAnswer } from "./buildExtendedAnswers";
import {
  ArrowLeftOutlined,
  ArrowUpOutlined,
  CaretDownFilled,
  CaretUpFilled,
  DeleteFilled,
  FieldTimeOutlined,
} from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Col,
  Divider,
  FloatButton,
  Form,
  Row,
  Space,
  Table,
  Tooltip,
  theme,
  AutoComplete,
  Flex,
  Radio,
  Checkbox,
  Select,
  InputNumber,
  Input,
} from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Heading from "../../../components/common/heading";
import NotFound from "../../../components/common/notFound";
import {
  BUSINESS_REQUIRE,
  COMPANY_TYPE,
  CUSTOMER_EXPECT,
  CUSTOMER_SUPPORT,
  DATA_MASTER_DATA_TYPE,
  ESTATE_TYPE,
  INDUSTRY,
  CURRENT_CUSTOMER_INDUSTRY_TYPE,
  OTHER_BUSINESS_EXPECT,
  OTHER_PRODUCT_EXPECT,
  OTHER_SUPPORT_EXPECT,
  PAGES,
  PERMISSION_DATA,
  PRODUCT_REQUIREMENT,
  REGION_GROUP,
  SUCCESS_CODE,
  TOUCH_POINT_CHANNEL_DIGITAL,
  TOUCH_POINT_CHANNEL_PHYSICAL,
  VOC_MASTER_DATA_TYPE,
  WORK_PERIOD,
} from "../../../lib/const";
import useCancelModal from "../../../lib/hooks/useCancelModal";
import useCountry from "../../../lib/hooks/useCountry";
import useEState from "../../../lib/hooks/useEState";
import useLineOfWork from "../../../lib/hooks/useLineOfWork";
import useMasterData from "../../../lib/hooks/useMasterData";
import usePermission from "../../../lib/hooks/usePermisson";
import usePosition from "../../../lib/hooks/usePosition";
import useStaffName from "../../../lib/hooks/useStaffName";
import { routes } from "../../../routes";
import { getCurrentCustomerByID } from "../../../services/customerCurrent";
import { downloadFile } from "../../../services/uploadFile";
import WithSidebar from "../../../templates/withSidebar";
import {MultipleAutoComplete,Autocomplete} from "../../../components/common/autoCompleteV2";
import "./style.css";

const { useToken } = theme;
const { Option } = Select;

const months = [
  {
    value: 1,
    name: "ตุลาคม",
  },
  {
    value: 2,
    name: "พฤศจิกายน",
  },
  {
    value: 3,
    name: "ธันวาคม",
  },
  {
    value: 4,
    name: "มกราคม",
  },
  {
    value: 5,
    name: "กุมภาพันธ์",
  },
  {
    value: 6,
    name: "มีนาคม",
  },
  {
    value: 7,
    name: "เมษายน",
  },
  {
    value: 8,
    name: "พฤษภาคม",
  },
  {
    value: 9,
    name: "มิถุนายน",
  },
  {
    value: 10,
    name: "กรกฎาคม",
  },
  {
    value: 11,
    name: "สิงหาคม",
  },
  {
    value: 12,
    name: "กันยายน",
  },
];

export const ViewCurrentCustomer = () => {

  //newTopic
    const [sellProductToData, setSellProductToData] = useState([]);
    const [checkedValues1, setCheckedValues1] = useState({});
    const [checkedValues2, setCheckedValues2] = useState({});
    const [disabled, setDisabled] = useState(true);
    const [taxRadio, setTaxRadio] = useState({
      importTax:{},
    })
    const [planRadio, setPlanRadio] = useState({
      capacity_plan:{},
    })
    const options = [
      { label: 'เพิ่ม', value: '1' },
      { label: 'ลด', value: '-1' },
      { label: 'เท่าเดิม', value: '0' },
  
    ];
    const options11 = [
      { label: 'เป็นไปตามแผน', value: '1' },
      { label: 'ไม่เป็นไปตามแผน', value: '0' },
    ];
    const options6 = [
      { label: 'มี', value: '1' },
      { label: 'ไม่มี', value: '0' },
    ];
    const options12 = [
      { label: 'ใช่', value: true },
      { label: 'ไม่ใช่', value: false },
    ];
    const planOptions = ['Solar Cell', 'น้ำ Recycle RO', 'พลังงานลม','พลังงานไฮโดรเจน','อื่นๆ'];
      const [modes, setModes] = useState({
        capacity: {},
        electricity: {},
        water: {},
        ro: {},
        CapacityPlan:{
          k:{
            choicesReducePlan: {}, 
            choicesFuturePlan: {},
            isSelectReduce: null,
            isSelectFuture: null,
            
          }
        },
      });
      const handleRadioLevelChange = (type, key, level) => (e) => {
        const value = e.target.value;
      
        setModes((prev) => {
          const prevData = prev[type]?.[key] || {};
      
          const newData = {
            ...prevData,
            [level]: value,
          }; 
          if (level === "choicesReducePlan") {
            if (value === "1") {
              newData.choicesFuturePlan = null;
              setCheckedValues2((prev) => ({ ...prev, [key]: [] }));
              form.setFieldsValue({
                isSelectFuture: [],
              });
            } else {
              form.setFieldsValue({
                isSelectReduce: [],
              });
              setCheckedValues1((prev) => ({ ...prev, [key]: [] }));
            }
          }
      
          if (level === "choicesFuturePlan" && value === "0") {
            form.setFieldsValue({
              isSelectFuture: [],
            });
            setCheckedValues2((prev) => ({ ...prev, [key]: [] }));
          }
      
          return {
            ...prev,
            [type]: {
              ...prev[type],
              [key]: newData,
            },
          };
        });
      };
    const handleRadioChange = (type, key) => (e) => {
      const value = e.target.value;
      setModes((prev) => ({
        ...prev,
        [type]: {
          ...prev[type],
          [key]: value,
        },
      }));
    
      if (type === "capacity") {
        setDisabled(value === "0");
    
        if (value === "0") {
          form.setFieldsValue({
            capacity_add: 0,
            capacity_sub: 0,
          });
        }
        if (value === "1") {
          form.setFieldsValue({
            capacity_sub: 0,
          });
        }
        if (value === "-1") {
          form.setFieldsValue({
            capacity_add: 0,
          });
        }
      }
    
      if (type === "electricity") {
        if (value === "0") {
          form.setFieldsValue({
            electricity_add: 0,
            electricity_sub: 0,
          });
        }
        if (value === "1") {
          form.setFieldsValue({
            electricity_sub: 0,
          });
        }
        if (value === "-1") {
          form.setFieldsValue({
            electricity_add: 0,
          });
        }
      }
      if (type === "water") {
        if (value === "0") {
          form.setFieldsValue({
            water_add: 0,
            water_sub: 0,
          });
        }
        if (value === "1") {
          form.setFieldsValue({
            water_sub: 0,
          });
        }
        if (value === "-1") {
          form.setFieldsValue({
            water_add: 0,
          });
        }
      }
      if (type === "ro") {
        if (value === "0") {
          form.setFieldsValue({
            ro_add: 0,
            ro_sub: 0,
          });
        }
        if (value === "1") {
          form.setFieldsValue({
            ro_sub: 0,
          });
        }
        if (value === "-1") {
          form.setFieldsValue({
            ro_add: 0,
          });
        }
      }
    };
    //

  const { token } = useToken();
  const navigate = useNavigate();
  const params = useParams();
  const [form] = Form.useForm();
  const { setOpenCancelModal, setPreviousPage } = useCancelModal();
  const [lineOfWork] = useLineOfWork();
  const [estate] = useEState();
  const values = Form.useWatch([], form);
  let [no, setNo] = useState(0);
  const [data, setData] = useState([]);
  const [summaryVisitor, setSummaryVisitor] = useState([]);

  const [regionGroup] = useMasterData(DATA_MASTER_DATA_TYPE, REGION_GROUP);
  const [workPeriod] = useMasterData(DATA_MASTER_DATA_TYPE, WORK_PERIOD);
  const [industryType] = useMasterData(DATA_MASTER_DATA_TYPE, CURRENT_CUSTOMER_INDUSTRY_TYPE);
  const [countries] = useCountry();
  const [companyType] = useMasterData(DATA_MASTER_DATA_TYPE, COMPANY_TYPE);
  const [industries] = useMasterData("", INDUSTRY);
  const [staffName] = useStaffName();
  const [position] = usePosition();
  const [estateType] = useMasterData(DATA_MASTER_DATA_TYPE, ESTATE_TYPE);

  const [fileList, setFileList] = useState([]);
  const [ckPosition, setCkPosition] = useState(0);
  const [visitors, setVisitors] = useState([]);

  const [touchPointChannel] = useMasterData(
    DATA_MASTER_DATA_TYPE,
    TOUCH_POINT_CHANNEL_DIGITAL
  );

  const [touchPointChannelPhysical] = useMasterData(
    DATA_MASTER_DATA_TYPE,
    TOUCH_POINT_CHANNEL_PHYSICAL
  );

  const [businessRequire] = useMasterData(
    VOC_MASTER_DATA_TYPE,
    BUSINESS_REQUIRE
  );
  const [customerExpect] = useMasterData(VOC_MASTER_DATA_TYPE, CUSTOMER_EXPECT);
  const [customerSupport] = useMasterData(
    VOC_MASTER_DATA_TYPE,
    CUSTOMER_SUPPORT
  );
  const [productRequirement] = useMasterData(
    VOC_MASTER_DATA_TYPE,
    PRODUCT_REQUIREMENT
  );
  const [otherBusinessExpect] = useMasterData(
    VOC_MASTER_DATA_TYPE,
    OTHER_BUSINESS_EXPECT
  );
  const [otherProductExpect] = useMasterData(
    VOC_MASTER_DATA_TYPE,
    OTHER_PRODUCT_EXPECT
  );
  const [otherSupportExpect] = useMasterData(
    VOC_MASTER_DATA_TYPE,
    OTHER_SUPPORT_EXPECT
  );

  const [roleUser] = usePermission(
    PERMISSION_DATA.APPLICATION,
    PAGES.CURRENT_CUSTOMER
  );

  const onDownloadFIle = async (fileName) => {
    const res = await downloadFile(fileName);

    if (
      res.headers["content-type"] === "application/octet-stream" ||
      res.headers["content-type"] === "application/pdf"
    ) {
      const blobFile = new Blob([res.data], {
        type: "application/pdf",
      });
      const href = URL.createObjectURL(blobFile);
      const downloadLink = document.createElement("a");
      downloadLink.href = href;
      downloadLink.download = fileName;
      document.body.appendChild(downloadLink);
      downloadLink.click();
    } else {
      const { objectValue } = res.data;
      if (objectValue) {
        const href = `${
          "data:" + res.headers["content-type"] + ";base64," + objectValue.bytes
        }`;
        const downloadLink = document.createElement("a");
        downloadLink.href = href;
        downloadLink.download = objectValue.fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
      }
    }
  };

  const fetchCustomer = useCallback(
    async (id) => {
      const res = await getCurrentCustomerByID(id);
      if (res.data.code === SUCCESS_CODE) {
        const { objectValue } = res.data;
        setData(objectValue);
        setSummaryVisitor(objectValue?.summaryVisitor);

        let files = [];
        // 15 Question
        let allSellList= [];
        let allBuyList= [];
        let allCountryList= [];
        let allTaxEffectList= [];
        for (let i = 0; i < objectValue?.summaryVisitor?.length; i++) {
          let _field = objectValue.summaryVisitor[i];
          for (let k = 0; k < _field.staffName?.length; k++) {
            for (let j = 0; j < staffName.length; j++) {
              if (_field.staffName[k] === staffName[j].id) {
                setVisitors((prev) => [
                  ...prev,
                  {
                    index: i,
                    id: staffName[j].id,
                    memberName: staffName[j].staffName,
                    memberLastname: staffName[j].staffLastname,
                    positionNo: staffName[j].position,
                  },
                ]);
              }
            }
          }
          
        // 15 Question
        let extended = _field?.summaryVisitorExtended?.[0] || {};

        let sellList = [];
    
        for (let k = 0; k < extended?.productSell?.length; k++) {
          sellList.push({
            productSell: extended?.productSell[k],
            companySell: extended?.companySell[k],
            industrySell: extended?.industrySell[k],
            
          });
          }
          allSellList.push(sellList);
          
          let buyList = [];
      
          for (let k = 0; k < extended?.productBuy?.length; k++) {
            buyList.push({
              productBuy: extended?.productBuy[k],
              companyBuy: extended?.companyBuy[k],
              industryBuy: extended?.industryBuy[k],
              
            });
          }
          allBuyList.push(buyList);

          let countryList = [];
      
          for (let k = 0; k < extended?.country_Import?.length; k++) {
            countryList.push({
              country_Import: extended?.country_Import[k],
            });
          }
          allCountryList.push(countryList);

          let taxEffectList = [];
      
          for (let k = 0; k < extended?.industryTaxImport?.length; k++) {
            taxEffectList.push({
              industryTaxImport: extended?.industryTaxImport[k],
              productTaxImport: extended?.productTaxImport[k],
            });
          }
          allTaxEffectList.push(taxEffectList);

          if (extended.capacity_add > 0) {
            modes.capacity[i] = "1";   // เพิ่ม
          } else if (extended.capacity_sub > 0) {
            modes.capacity[i] = "-1";  // ลด
          } else {
            modes.capacity[i] = "0";   // เท่าเดิม
          }

          if (extended.electricity_add > 0) {
            modes.electricity[i] = "1";   // เพิ่ม
          } else if (extended.electricity_sub > 0) {
            modes.electricity[i] = "-1";  // ลด
          } else {
            modes.electricity[i] = "0";   // เท่าเดิม
          }

          if (extended.water_add > 0) {
            modes.water[i] = "1";   // เพิ่ม
          } else if (extended.water_sub > 0) {
            modes.water[i] = "-1";  // ลด
          } else {
            modes.water[i] = "0";   // เท่าเดิม
          }

          if (extended.ro_add > 0) {
            modes.ro[i] = "1";   // เพิ่ม
          } else if (extended.ro_sub > 0) {
            modes.ro[i] = "-1";  // ลด
          } else {
            modes.ro[i] = "0";   // เท่าเดิม
          }
          
          form.setFieldsValue({
            importTax: extended.importTax,
            
          });
          



          //

          if (_field?.filePath) {
            const res = await downloadFile(_field?.filePath);
            if (res.data.code === SUCCESS_CODE) {
              const { objectValue } = res.data;

              files.push({
                index: i,
                file: objectValue?.fileName,
                name: objectValue?.fileName,
                status: "done",
                uid: _field?.summaryId,
                url: "",
              });
            }
          }
          form.setFields([
            // 15 Question
            {
              name: ["capacity_add", i],
              value: extended.capacity_add,
            },
            {
              name: ["capacity_sub", i],
              value: extended.capacity_sub,
            },
            {
              name: ["electricity_add", i],
              value: extended.electricity_add,
            },
            {
              name: ["electricity_sub", i],
              value: extended.electricity_sub,
            },
            {
              name: ["water_add", i],
              value: extended.water_add,
            },
            {
              name: ["water_sub", i],
              value: extended.water_sub,
            },
            {
              name: ["ro_add", i],
              value: extended.ro_add,
            },
            {
              name: ["ro_sub", i],
              value: extended.ro_sub,
            },
            {
              name: ["solarcellCapacity", i],
              value: extended.solarcellCapacity,
            },
            {
              name: ["waterUsage", i],
              value: extended.waterUsage,
            },
            {
              name: ["electricityUsage", i],
              value: extended.electricityUsage,
            },
            {
              name: ["wasteWaterVolume", i],
              value: extended.wasteWaterVolume,
            },
            {
              name: ["capacity_plan", i],
              value: extended.capacity_plan,
            },
            {
              name: ["estimatedCost", i],
              value: extended.estimatedCost,
            },
            {
              name: ["remark_ieat", i],
              value: extended.remark_ieat,
            },
            {
              name: ["interestDetail", i],
              value: extended.interestDetail,
            },
            {
              name: ["smesInterest", i],
              value: extended.smesInterest,
            },
            {
              name: ["innovationInterest", i],
              value: extended.innovationInterest,
            },
            
          ]);
          setModes((prev) => {
            // clean ค่า "อื่นๆ: ..." เหลือแค่ "อื่นๆ"
            const cleanIsSelectFuture = Array.isArray(extended.isSelectFuture)
              ? extended.isSelectFuture.map((item) =>
                  item.startsWith("อื่นๆ") ? "อื่นๆ" : item
                )
              : [];
          
            const cleanIsSelectReduce = Array.isArray(extended.isSelectReduce)
              ? extended.isSelectReduce.map((item) =>
                  item.startsWith("อื่นๆ") ? "อื่นๆ" : item
                )
              : [];
          
            const updatedModes = {
              ...prev,
              CapacityPlan: {
                ...prev.CapacityPlan,
                [i]: {
                  ...prev.CapacityPlan[i],
                  choicesReducePlan: extended.isCheckReduce ? "1" : "0",
                  choicesFuturePlan: extended.isCheckFuture ? "1" : "0",
                  isSelectReduce: cleanIsSelectReduce,
                  isSelectFuture: cleanIsSelectFuture,
                },
              },
            };
            return updatedModes;
          });
          setTaxRadio((prev) => {
            const updated = {
              ...prev,
              importTax: {
                ...prev.importTax,
                [i]: extended.importTax,
              },
            };
            form.setFieldsValue({
              importTax: {
                ...form.getFieldValue("importTax"),
                [i]: readBooleanAnswer(extended.importTax),
              },
            });
          
            return updated;
          });
          setPlanRadio((prev) => {
            const updated = {
              ...prev,
              capacity_plan: {
                ...prev.capacity_plan,
                [i]: extended.capacity_plan,
              },
            };
            form.setFieldsValue({
              capacity_plan: {
                ...form.getFieldValue("capacity_plan"),
                [i]: readBooleanAnswer(extended.capacity_plan),
              },
            });
            
          
            return updated;
          });
          const setOtherValue = (fieldName, data) => {
            const otherItem = data?.find((text) => text.startsWith("อื่นๆ"));
            if (otherItem) {
              const otherText = otherItem.split(":")[1]?.trim();
              form.setFieldsValue({
                [fieldName]: {
                  [i]: otherText,
                },
              });
            }
          };
          setOtherValue("otherFuture", extended.isSelectFuture);
          setOtherValue("otherReduce", extended.isSelectReduce);
        }

        setFileList(files);
        // 15 Question
        form.setFieldsValue({
          sellProductTo : allSellList,
          buyProductFrom : allBuyList,
          bigImportTo : allCountryList,
          TaxEffect : allTaxEffectList,
          
        });
      }
    },
    [setSummaryVisitor, setVisitors, staffName, setData ,setPlanRadio,setTaxRadio]
  );

  useEffect(() => {
    fetchCustomer(params.id);
  }, [params.id, fetchCustomer]);

  const columns = [
    {
      title: "ชื่อ-นามสกุล",
      dataIndex: "memberName",
      key: "memberName",
      render: (_, record) => (
        <>
          <span>{record?.memberName}</span>{" "}
          <span>{record?.memberLastname}</span>
        </>
      ),
    },
    // {
    //   title: "ตำแหน่ง",
    //   dataIndex: "positionNo",
    //   key: "positionNo",
    // },
    {
      align: "center",
      width: 120,
      title: "คำสั่ง",
      render: (_, record) => (
        <Space>
          <Tooltip placement="bottom" title={"ลบ"}>
            <Button
              style={{ backgroundColor: "#FDE7E5", border: 0 }}
              shape="circle"
            >
              <DeleteFilled style={{ color: "#F04438" }} />
            </Button>
          </Tooltip>
        </Space>
      ),
    },
  ];

  const collapseElems = (el) => {
    setSummaryVisitor(
      summaryVisitor.map((item) =>
        item.summaryId === el.summaryId
          ? {
              ...item,
              collapse: !el?.collapse,
            }
          : {
              ...item,
              collapse: false,
            }
      )
    );
  };

  return (
    <WithSidebar>
      <div>
        <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
          <Col span={24}>
            <div className="flex items-center">
              <Space size={12}>
                <Button
                  type="link"
                  onClick={() => {
                    setOpenCancelModal(true);
                    setPreviousPage(routes.customer_tab_current);
                  }}
                  style={{ padding: 0 }}
                >
                  <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                </Button>
                <Heading text={"รายละเอียด"} size={4} style={{ margin: 0 }} />
              </Space>
            </div>
            <Breadcrumb
              style={{ paddingTop: 10 }}
              items={[
                {
                  title: "คลังข้อมูลลูกค้าปัจจุบัน ",
                },
                {
                  title: <span className="pr_green">รายละเอียด</span>,
                },
              ]}
            />
          </Col>

          <Col span={24}>
            <Form
              form={form}
              layout="vertical"
              style={{ width: "100%", padding: "0 30px" }}
            >
              {roleUser[0]?.isEdit && (
                <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                  <Col span={24} align="right">
                    <Space>
                      <Button
                        type="primary"
                        onClick={() =>
                          navigate(
                            routes.edit_customer_current + "/" + params.id
                          )
                        }
                      >
                        แก้ไข
                      </Button>
                    </Space>
                  </Col>
                </Row>
              )}

              <Row
                gutter={[16, 24]}
                className="card"
                style={{ marginBottom: 30 }}
              >
                <Col span={24}>
                  <Heading
                    text={"ข้อมูลลูกค้าปัจจุบัน"}
                    size={4}
                    style={{ margin: 0, color: token.thPrimary }}
                  />
                  <Divider />
                </Col>

                <Col span={16}>
                  <Form.Item label="DBD Register number" className="view-label">
                    {data?.dbdRegisterNumber || "-"}
                  </Form.Item>
                </Col>
                <Col span={16}>
                  <Form.Item
                    label="ชื่อสถานประกอบการ/ชื่อโรงงาน (TH)"
                    className="view-label"
                  >
                    {data?.factoryNameTh || "-"}
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="ชื่อสถานประกอบการ/ชื่อโรงงาน (EN)"
                    className="view-label"
                  >
                    {data?.factoryNameEn || "-"}
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Row gutter={[8, 16]}>
                    <Col span={24}>
                      <Form.Item label="สายงาน" className="view-label">
                        {
                          data?.lineOfWorkId ? lineOfWork.find((e) => e?.lineOfWork === data?.lineOfWorkId)?.nameTh || "-" : "-"
                        }
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="นิคมอุตสาหกรรม/ท่าเรืออุตสาหกรรม"
                        className="view-label"
                      >
                        {
                          data?.estateNameEn?.length > 0 ?
                            data.estateNameEn
                              .filter((id) => id && id.trim() !== "") // ตัดค่าว่างออก
                              .map((id) => estate?.find((item) => item.estateId === id)?.estateNameTh) // ค้นหาชื่อ
                              .filter((name) => name) // กรองค่า undefined ทิ้ง (กรณีหา ID ไม่เจอ)
                              .join(", ") || "-" // นำคำมาต่อกันด้วยลูกน้ำ ถ้าผลลัพธ์ว่างเปล่าให้แสดง "-"
                            : "-"
                        }
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item label="ประเภทนิคมอุตสาหกรรม" className="view-label">
                        {
                          data?.estateId?.length > 0 ?
                            data.estateId
                              .filter((id) => id && id.trim() !== "") // ตัดค่าว่างออก
                              .map((id) => estateType?.find((item) => item.dataId === id)?.dataDetailTh) // ค้นหาชื่อ
                              .filter((name) => name) // กรองค่า undefined ทิ้ง (กรณีหา ID ไม่เจอ)
                              .join(", ") || "-" // นำคำมาต่อกันด้วยลูกน้ำ ถ้าผลลัพธ์ว่างเปล่าให้แสดง "-"
                            : "-"
                        }
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>

                <Col span={16}>
                  <Form.Item label="กลุ่มลูกค้าตามอายุ" className="view-label">
                    {data?.customerGroupByAge
                      ? workPeriod.map((item) =>
                          item.dataId === data?.customerGroupByAge
                            ? item.dataDetailTh
                            : ""
                        )
                      : "-"}
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="กลุ่มลูกค้าตามสัญชาติ"
                    className="view-label"
                  >
                    {data?.customerGroupByRegion
                      ? (() => {
                          let rows = [];
                          const arr = data?.customerGroupByRegion;
                          for (let i = 0; i < arr?.length; i++) {
                            for (const item of regionGroup) {
                              if (arr[i] === item.dataId) {
                                let _comma = "";
                                if (i < arr?.length - 1) {
                                  _comma = ", ";
                                }
                                rows.push(item.dataDetailTh + _comma);
                              }
                            }
                          }
                          return rows;
                        })()
                      : "-"}
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="สัญชาติลูกค้า (ประเทศ)  "
                    className="view-label"
                  >
                    {data?.customerRegion
                      ? countries.map((item, _index) => {
                          let arr = data?.customerRegion;
                          let value = [];
                          for (let i = 0; i < arr.length; i++) {
                            if (arr[i] === item.countryId) {
                              let _comma = "";
                              if (_index + 1 < data?.customerRegion?.length) {
                                _comma = ", ";
                              }
                              value.push(item.countryNameTh + _comma);
                            }
                          }
                          return value;
                        })
                      : "-"}
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Row gutter={[8, 16]}>
                    <Col span={12}>
                      <Form.Item
                        label="ลูกค้าตามกลุ่มอุตสาหกรรม"
                        className="view-label"
                      >
                        {data?.customerGroupByEstateType
                          ? industryType.map((item) => {
                              return item.dataId ===
                                data?.customerGroupByEstateType
                                ? item.dataDetailTh
                                : "";
                            })
                          : "-"}
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="ประเภทอุตสาหกรรม"
                        className="view-label"
                      >
                        {data?.typeOfEstate
                          ? industries.map((item) => {
                              return item.industryId === data?.typeOfEstate
                                ? item.industryNameTh
                                : "";
                            })
                          : "-"}
                      </Form.Item>
                      {data?.typeOfEstate && (
                        <Form.Item label="" style={{ marginTop: 8 }}>
                          {data?.typeOfEstateSpecify}
                        </Form.Item>
                      )}
                    </Col>
                    <Col span={12}>
                      <Form.Item label="ประเภทกิจการ" className="view-label">
                        {data?.typeOfBusiness
                          ? companyType.map((item) =>
                              item.dataId === data?.typeOfBusiness
                                ? item.dataDetailTh
                                : ""
                            )
                          : "-"}
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>

              {summaryVisitor.length > 0 && (
                <Row
                  gutter={[16, 8]}
                  className="card addElement"
                  style={{ marginBottom: 50 }}
                >
                  <Col span={24}>
                    <Heading
                      text={"Summary สรุปการเยี่ยมชม"}
                      size={4}
                      style={{ margin: 0, color: token.thPrimary }}
                    />
                    <Divider />
                  </Col>

                  {summaryVisitor &&
                    summaryVisitor.map((el, k) => (
                      <Col key={k} span={24}>
                        <div
                          className={`relative`}
                          style={{
                            padding: 15,
                            marginBottom: 20,
                            width: "80%",
                            border: "1px solid #E5EAEE",
                            borderRadius: 10,
                          }}
                        >
                          <Row
                            gutter={[16, 16]}
                            className={`${
                              el.collapse ? "" : "view-current-custom-collapse"
                            }`}
                          >
                            <div className="current-custom-collapse-btn">
                              <Button
                                shape="circle"
                                size="small"
                                style={{
                                  backgroundColor: "#F4F6FC",
                                  border: 0,
                                  marginLeft: 5,
                                }}
                                onClick={() => collapseElems(el)}
                              >
                                {el.collapse ? (
                                  <CaretUpFilled
                                    style={{
                                      color: "#2E90FA",
                                      fontSize: 16,
                                    }}
                                  />
                                ) : (
                                  <CaretDownFilled
                                    style={{
                                      color: "#2E90FA",
                                      fontSize: 16,
                                    }}
                                  />
                                )}
                              </Button>
                            </div>

                            <Col span={24} style={{ marginBottom: 10 }}>
                              <Row gutter={[16, 24]}>
                                <Col span={12}>
                                  <div
                                    style={{
                                      fontWeight: 600,
                                      fontSize: 16,
                                    }}
                                  >
                                    ข้อมูลการเข้าเยี่ยมชมลูกค้า
                                  </div>
                                </Col>

                                <Col span={12} align="right">
                                  <div
                                    style={{
                                      fontSize: 14,
                                      color: "#65707A",
                                    }}
                                  >
                                    <FieldTimeOutlined
                                      style={{ color: "#2E90FA" }}
                                    />{" "}
                                    อัพเดทล่าสุด :{" "}
                                    {el?.updateDate ? el?.updateDate : "-"}
                                  </div>
                                </Col>
                              </Row>
                            </Col>

                            <Col span={24}>
                              <Form.Item
                                label="นิคมอุตสาหกรรม/ท่าเรืออุตสาหกรรม"
                                className="view-label"
                              >
                                {estate.map((item) => {
                                  for (
                                    let index = 0;
                                    index < el?.summaryEstateId.length;
                                    index++
                                  ) {
                                    const element = el?.summaryEstateId[index];
                                    if (element === item.estateId) {
                                      return item.estateNameTh + " ";
                                    }
                                  }
                                })}
                              </Form.Item>
                            </Col>

                            <Col span={12}>
                              <Form.Item
                                label="ปีงบประมาณ"
                                className="view-label"
                              >
                                {parseInt(el?.yearOfBudget) + 543 || "-"}
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item label="เดือน" className="view-label">
                                {months.map(
                                  (m) =>
                                    m.value === parseInt(el?.monthOfBudget) &&
                                    "เดือน " +
                                      el?.monthOfBudget +
                                      " (" +
                                      m.name +
                                      ")"
                                )}
                                {!el?.monthOfBudget && "-"}
                              </Form.Item>
                            </Col>

                            <Col span={24}>
                              <div
                                style={{ color: "#499D96", fontWeight: 600 }}
                              >
                                ชื่อเจ้าหน้าที่เข้าเยี่ยมลูกค้า
                              </div>
                              <div style={{ marginTop: 5 }}>
                                <span
                                  style={{ fontWeight: 500, marginBottom: 5 }}
                                >
                                  จำนวนรายชื่อทั้งหมด{" "}
                                  <span
                                    className="pr-purple"
                                    style={{ fontWeight: 600 }}
                                  >
                                    {
                                      visitors.filter(
                                        (obj, index) =>
                                          visitors.findIndex(
                                            (item) =>
                                              item.id === obj.id &&
                                              item.index === k
                                          ) === index
                                      ).length
                                    }
                                  </span>{" "}
                                  คน
                                </span>
                                <Table
                                  locale={{
                                    emptyText: (
                                      <NotFound text="สามารถเพิ่มรายชื่อได้ที่ช่องกรอกด้านบน “เจ้าหน้าที่เข้าเยี่ยมลูกค้า”" />
                                    ),
                                  }}
                                  columns={columns}
                                  dataSource={
                                    visitors.length > 0
                                      ? visitors.filter(
                                          (obj, index) =>
                                            visitors.findIndex(
                                              (item) =>
                                                item.id === obj.id &&
                                                item.index === k
                                            ) === index
                                        )
                                      : undefined
                                  }
                                  size="small"
                                  pagination={false}
                                  scroll={{
                                    y: 200,
                                  }}
                                />
                              </div>
                            </Col>

                            <Col span={24}>
                              <Divider dashed />
                            </Col>

                            <Col span={24}>
                              <Form.Item
                                label="ชื่อ-นามสกุล ผู้จัดทำรายงาน"
                                className=" view-label"
                              >
                                {el?.reporterName
                                  ? staffName?.map(
                                      (item) =>
                                        item.id === el?.reporterName[0] &&
                                        item.value
                                    )
                                  : "-"}
                              </Form.Item>
                            </Col>

                            <Col span={12}>
                              <Form.Item
                                label="ตำแหน่งผู้จัดทำรายงาน"
                                className=" view-label"
                              >
                                {el?.reporterPosition
                                  ? position.map(
                                      (item) =>
                                        item.id === el?.reporterPosition &&
                                        item.value
                                    )
                                  : "-"}
                              </Form.Item>
                            </Col>

                            <Col span={12}>
                              <Form.Item
                                label="เบอร์โทรผู้จัดทำรายงาน"
                                className=" view-label"
                              >
                                {el?.reporterPhoneNumber || "-"}
                              </Form.Item>
                            </Col>

                            <Col span={12}>
                              <Form.Item
                                label="E-mail ผู้จัดทำรายงาน"
                                className="view-label"
                              >
                                {el?.reporterEmail || "-"}
                              </Form.Item>
                            </Col>

                            <Col span={24}>
                              <Divider dashed />
                            </Col>

                            <Col span={24}>
                              <div style={{ fontWeight: 600, fontSize: 16 }}>
                                ข้อมูลลูกค้า
                              </div>
                            </Col>

                            <Col span={8}>
                              <Form.Item
                                label="ขนาดพื้นที่ (ไร่)"
                                className="view-label"
                              >
                                {parseFloat(el?.areaSizeByRai).toFixed(2)}
                              </Form.Item>
                            </Col>

                            <Col span={8}>
                              <Form.Item
                                label="ขนาดพื้นที่ (งาน)"
                                className="view-label"
                              >
                                {parseFloat(el?.areaSizeByNgan).toFixed(2)}
                              </Form.Item>
                            </Col>

                            <Col span={8}>
                              <Form.Item
                                label="ขนาดพื้นที่ (วา)"
                                className="view-label"
                              >
                                {parseFloat(el?.areaSizeByWa).toFixed(2)}
                              </Form.Item>
                            </Col>

                            <Col span={8}>
                              <Form.Item
                                label="ขนาดพื้นที่ (ตารางเมตร)"
                                className="view-label"
                              >
                                {parseFloat(el?.areaSizeByMeters).toFixed(2)}
                              </Form.Item>
                            </Col>

                            <Col span={8}>
                              <Form.Item
                                label="ปริมาณการใช้น้ำต่อเดือน ลูกบาศก์เมตร (ลบ.ม.)"
                                className="view-label"
                              >
                                {parseFloat(el?.waterConsumption).toFixed(2)}
                              </Form.Item>
                            </Col>

                            <Col span={8}>
                              <Form.Item
                                label="จำนวนคนงาน"
                                className="view-label"
                              >
                                {el?.numberOfWorker}
                              </Form.Item>
                            </Col>

                            <Col span={12}>
                              <Form.Item
                                label="ชื่อผู้บริหารโรงงานที่พบ"
                                className="view-label"
                              >
                                {el?.ceoNameOfFactory || "-"}
                              </Form.Item>
                            </Col>

                            <Col span={12}>
                              <Form.Item
                                label="ตำแหน่งผู้บริหารที่เข้าพบ"
                                className="view-label"
                              >
                                {el?.ceoPositionOfFactory || "-"}
                              </Form.Item>
                            </Col>

                            <Col span={12}>
                              <Form.Item
                                label="ชื่อผู้ติดต่อ/ผู้ประสานงาน"
                                className="view-label"
                              >
                                {el?.coordinatorName || "-"}
                              </Form.Item>
                            </Col>

                            <Col span={12}>
                              <Form.Item
                                label="เบอร์โทรศัพท์ผู้ติดต่อ/ผู้ประสานงาน"
                                className="view-label"
                              >
                                {el?.coordinatorPhoneNumber || "-"}
                              </Form.Item>
                            </Col>

                            <Col span={12}>
                              <Form.Item
                                label="อีเมลผู้ติดต่อ/ผู้ประสานงาน"
                                className="view-label"
                              >
                                {el?.coordinatorEmail +
                                  "/" +
                                  el?.coordinatorName}
                              </Form.Item>
                            </Col>

                            <Col span={16}>
                              <Form.Item
                                label="แนบไฟล์ "
                                className="view-label"
                              >
                                {el?.filePath ? (
                                  <Button
                                    type="link"
                                    onClick={() => onDownloadFIle(el?.filePath)}
                                  >
                                    <div class="ant-upload-icon">
                                      <span
                                        role="img"
                                        aria-label="paper-clip"
                                        class="anticon anticon-paper-clip"
                                      >
                                        <svg
                                          viewBox="64 64 896 896"
                                          focusable="false"
                                          data-icon="paper-clip"
                                          width="1em"
                                          height="1em"
                                          fill="currentColor"
                                          aria-hidden="true"
                                        >
                                          <path d="M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z"></path>
                                        </svg>
                                      </span>{" "}
                                      {fileList.length > 0
                                        ? fileList.map(
                                            (item) =>
                                              k === item.index && item.name
                                          )
                                        : el?.filePath}
                                    </div>
                                  </Button>
                                ) : (
                                  "-"
                                )}
                              </Form.Item>
                            </Col>

                            <Col span={24}>
                              <Divider dashed />
                            </Col>

                            <Col span={24}>
                              <div style={{ fontWeight: 600, fontSize: 16 }}>
                                ด้านผลิตภัณฑ์และบริการ
                              </div>
                            </Col>

                            <Col span={24}>
                              <Form.Item
                                label="1. ลูกค้ามีความต้องการ ด้านผลิตภัณฑ์และบริการ ของ กนอ. อย่างไร  "
                                className="view-label"
                              >
                                <ul>
                                  {productRequirement.map((item) => {
                                    for (
                                      let index = 0;
                                      index < el?.productAndServiceWant.length;
                                      index++
                                    ) {
                                      const element =
                                        el?.productAndServiceWant[index];
                                      if (element === item.vocUniqueId) {
                                        return (
                                          <li key={item.vocUniqueId}>
                                            {item.vocDetailTh}
                                          </li>
                                        );
                                      }
                                    }
                                  })}
                                  {el?.productAndServiceWant.includes(
                                    "-99"
                                  ) && <li>อื่นๆ</li>}
                                </ul>

                                {el?.productAndServiceWantSpecify && (
                                  <Form.Item
                                    label=""
                                    style={{ marginLeft: 30 }}
                                  >
                                    รายละเอียด (อื่นๆ) :{" "}
                                    {el?.productAndServiceWantSpecify || "-"}
                                  </Form.Item>
                                )}
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="2. ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านผลิตภัณฑ์"
                                className="view-label"
                              >
                                <ul>
                                  {otherProductExpect.map((item) => {
                                    for (
                                      let index = 0;
                                      index <
                                      el?.productAndServiceExpected.length;
                                      index++
                                    ) {
                                      const element =
                                        el?.productAndServiceExpected[index];
                                      if (element === item.vocUniqueId) {
                                        return (
                                          <li key={item.vocUniqueId}>
                                            {item.vocDetailTh}
                                          </li>
                                        );
                                      }
                                    }
                                  })}
                                  {el?.productAndServiceExpected.includes(
                                    "-99"
                                  ) && <li>อื่นๆ</li>}
                                </ul>

                                {el?.productAndServiceExpectedSpecify && (
                                  <Form.Item
                                    label=""
                                    style={{ marginLeft: 30 }}
                                  >
                                    รายละเอียด (อื่นๆ) :{" "}
                                    {el?.productAndServiceExpectedSpecify ||
                                      "-"}
                                  </Form.Item>
                                )}
                              </Form.Item>
                            </Col>

                            <Col span={24}>
                              <div
                                style={{
                                  fontWeight: 600,
                                  fontSize: 16,
                                  marginTop: 20,
                                }}
                              >
                                ด้านสนับสนุนลูกค้า
                              </div>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="1.ลูกค้ามีความต้องการ ด้านสนับสนุนลูกค้า ของ กนอ. อย่างไร "
                                className="view-label"
                              >
                                <ul>
                                  {customerSupport.map((item) => {
                                    for (
                                      let index = 0;
                                      index < el?.supportWant.length;
                                      index++
                                    ) {
                                      const element = el?.supportWant[index];
                                      if (element === item.vocUniqueId) {
                                        return (
                                          <li key={item.vocUniqueId}>
                                            {item.vocDetailTh}
                                          </li>
                                        );
                                      }
                                    }
                                  })}
                                  {el?.supportWant.includes("-99") && (
                                    <li>อื่นๆ</li>
                                  )}
                                </ul>

                                {el?.supportWantSpecify && (
                                  <Form.Item
                                    label=""
                                    style={{ marginLeft: 30 }}
                                  >
                                    รายละเอียด (อื่นๆ) :{" "}
                                    {el?.supportWantSpecify || "-"}
                                  </Form.Item>
                                )}
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="2.ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านสนับสนุนลูกค้า ของ กนอ. อย่างไร "
                                className="view-label"
                              >
                                <ul>
                                  {otherSupportExpect.map((item) => {
                                    for (
                                      let index = 0;
                                      index < el?.supportExpected.length;
                                      index++
                                    ) {
                                      const element =
                                        el?.supportExpected[index];
                                      if (element === item.vocUniqueId) {
                                        return (
                                          <li key={item.vocUniqueId}>
                                            {item.vocDetailTh}
                                          </li>
                                        );
                                      }
                                    }
                                  })}
                                  {el?.supportExpected.includes("-99") && (
                                    <li>อื่นๆ</li>
                                  )}
                                </ul>

                                {el?.supportExpectedSpecify && (
                                  <Form.Item
                                    label=""
                                    style={{ marginLeft: 30 }}
                                  >
                                    รายละเอียด (อื่นๆ) :{" "}
                                    {el?.supportExpectedSpecify || "-"}
                                  </Form.Item>
                                )}
                              </Form.Item>
                            </Col>

                            <Col span={24}>
                              <div
                                style={{
                                  fontWeight: 600,
                                  fontSize: 16,
                                  marginTop: 20,
                                }}
                              >
                                ด้านการทำธุรกรรม
                              </div>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="1.ลูกค้ามีความต้องการ ด้านการทำธุรกรรม (อนุมัติอนุญาตสิทธิประโยชน์) ของ กนอ. อย่างไร "
                                className="view-label"
                              >
                                <ul>
                                  {businessRequire.map((item) => {
                                    for (
                                      let index = 0;
                                      index < el?.transactionWant.length;
                                      index++
                                    ) {
                                      const element =
                                        el?.transactionWant[index];
                                      if (element === item.vocUniqueId) {
                                        return (
                                          <li key={item.vocUniqueId}>
                                            {item.vocDetailTh}
                                          </li>
                                        );
                                      }
                                    }
                                  })}
                                  {el?.transactionWant.includes("-99") && (
                                    <li>อื่นๆ</li>
                                  )}
                                </ul>

                                {el?.transactionWantSpecify && (
                                  <Form.Item
                                    label=""
                                    style={{ marginLeft: 30 }}
                                  >
                                    รายละเอียด (อื่นๆ) :{" "}
                                    {el?.transactionWantSpecify || "-"}
                                  </Form.Item>
                                )}
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="2.ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านการทำธุรกรรม (อนุมัติอนุญาตสิทธิประโยชน์) ของ กนอ. อย่างไร"
                                className="view-label"
                              >
                                <ul>
                                  {otherBusinessExpect.map((item) => {
                                    for (
                                      let index = 0;
                                      index < el?.transactionExpected.length;
                                      index++
                                    ) {
                                      const element =
                                        el?.transactionExpected[index];
                                      if (element === item.vocUniqueId) {
                                        return (
                                          <li key={item.vocUniqueId}>
                                            {item.vocDetailTh}
                                          </li>
                                        );
                                      }
                                    }
                                  })}
                                  {el?.transactionExpected.includes("-99") && (
                                    <li>อื่นๆ</li>
                                  )}
                                </ul>

                                {el?.transactionExpectedSpecify && (
                                  <Form.Item
                                    label=""
                                    style={{ marginLeft: 30 }}
                                  >
                                    รายละเอียด (อื่นๆ) :{" "}
                                    {el?.transactionExpectedSpecify || "-"}
                                  </Form.Item>
                                )}
                              </Form.Item>
                            </Col>

                            <Col span={24}>
                              <div
                                style={{
                                  fontWeight: 600,
                                  fontSize: 16,
                                  marginTop: 20,
                                }}
                              >
                                ด้านการจัดการความสัมพันธ์ (CRM)
                              </div>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="1.ลูกค้ามีความต้องการ/คาดหวัง ด้านการจัดการความสัมพันธ์(CRM) ของ กนอ. อย่างไร "
                                className="view-label"
                              >
                                <ul>
                                  {customerExpect.map((item) => {
                                    for (
                                      let index = 0;
                                      index < el?.crmExpected.length;
                                      index++
                                    ) {
                                      const element = el?.crmExpected[index];
                                      if (element === item.vocUniqueId) {
                                        return (
                                          <li key={item.vocUniqueId}>
                                            {item.vocDetailTh}
                                          </li>
                                        );
                                      }
                                    }
                                  })}
                                  {el?.crmExpected.includes("-99") && (
                                    <li>อื่นๆ</li>
                                  )}
                                </ul>
                                {el?.crmExpectedSpecify && (
                                  <Form.Item
                                    label=""
                                    style={{ marginLeft: 30 }}
                                  >
                                    รายละเอียด (อื่นๆ) :{" "}
                                    {el?.crmExpectedSpecify || "-"}
                                  </Form.Item>
                                )}
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="2.ข้อเสนอแนะด้านผลิตภัณฑ์และบริการ"
                                className="view-label"
                              >
                                {el?.productAndServiceSuggestion || "-"}
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="3.ข้อเสนอแนะด้านสนับสนุนลูกค้า "
                                className="view-label"
                              >
                                {el?.supportSuggestion || "-"}
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="4.ข้อเสนอแนะด้านการทำธุรกรรม (อนุมัติ, อนุญาตและสิทธิประโยชน์)"
                                className="view-label"
                              >
                                {el?.transactionSuggestion || "-"}
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="5.ข้อเสนอแนะด้านการจัดการความสัมพันธ์กับลูกค้า (CRM) "
                                className="view-label"
                              >
                                {el?.crmSuggestion || "-"}
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="6.สิ่งที่ไม่พึ่งพอใจต้องการให้ปรับปรุงอย่างเร่งด่วน"
                                className="view-label"
                              >
                                {el?.notSatisfied || "-"}
                              </Form.Item>
                            </Col>
                            <div>
                              <Col span={24}>
                                <div
                                  style={{
                                    fontWeight: 600,
                                    fontSize: 30,
                                    marginTop: 20,
                                  }}
                                >
                                  คำถามใหม่
                                </div>
                              </Col>
                              <Col span={24}>
    
                                <Row gutter={16}>
                                  <Col span={24}>
                                    <Form.Item
                                      className="view-label"
                                      label="1.บริษัทขายสินค้าอะไร ให้กับบริษัทอะไร"
                                    >
                                    
                                  <Form.List name={["sellProductTo",`${k}`]}>
                                    {(fields, { add, remove }) => (
                                      <>
                                        {fields.map(({ key, name}) => (
                                          <Col span={24} key={key}>
                                            <Row gutter={16}> 
                                              <Col span={7}>
                                                <Form.Item
                                                  name={[name, "productSell"]}
                                                  
                                                >
                                                 สินค้า : {el.summaryVisitorExtended?.[0]?.productSell?.[name] || "-"}
                                                </Form.Item>
                                              </Col>
    
                                              <Col span={7}>
                                                <Form.Item
                                                  name={[name, "companySell"]}
                                                  
                                                >
                                                 {el.summaryVisitorExtended?.[0]?.companySell?.[name] || "-"}

                                                </Form.Item>
                                              </Col>
    
                                              <Col span={7}>
                                                <Form.Item
                                                  name={[name, "industrySell"]} // เชื่อมโยงชื่อที่ตรงกัน
                                                  
                                                >
                                                 {
                                                    industries.find(
                                                      (item) => item.industryId === el.summaryVisitorExtended?.[0]?.industrySell?.[name]
                                                    )?.industryNameTh || "-"
                                                  }
                                                </Form.Item>
                                              </Col>
    
                                              
                                              
                                            </Row>
                                          </Col>
                                        ))}
                                        
                                      </>
                                    )}
                                  </Form.List>
                                  </Form.Item>
                                  </Col>

    
                                </Row>
                                  
                                
                              </Col>
                              <Col span={24}>
    
                                <Row gutter={16}>
                                <Col span={24}><Form.Item
                                      className="view-label"
                                      label="2.บริษัทซื้อสินค้าอะไร จากบริษัทอะไร"
                                    >
                                <Form.List name={["buyProductFrom",`${k}`]}>
                                    {(fields, { add, remove }) => (
                                      <>
                                      {fields.map(({ key, name, ...restField }, k) => (
                                        <Col span ={24}>
                                        <Row gutter={16} key={key}>
                                    <Col span={7}>
                                      <Form.Item
                                      name={[name,"productBuy"]}
                                      
                                    >
                                      สินค้า : {el.summaryVisitorExtended?.[0]?.productBuy?.[name] || "-"}

                                      </Form.Item>
                                    </Col>
                                    <Col span={7}>
                                      <Form.Item
                                          name={[name,"companyBuy"]}
                                        >
                                          {el.summaryVisitorExtended?.[0]?.companyBuy?.[name] || "-"}

                                        </Form.Item>
                                      </Col>
                                      <Col span={7}>
                                      <Form.Item
                                            name={[name,"industryBuy"]}
                                          
                                        >
                                          {
                                            industries.find(
                                              (item) => item.industryId === el.summaryVisitorExtended?.[0]?.industrySell?.[name]
                                            )?.industryNameTh || "-"
                                          }
                                        </Form.Item>
                                      </Col>
                                      
                                      
                                    </Row>
                                  </Col>
                                ))}
                                      </>
                                  )}
                                  </Form.List>
                                </Form.Item>
                                </Col>
                              </Row>
                                
                                  
                                
                              </Col>
                              <Col span={24}>
                                <Row gutter={16}>
                                <Col span={24}>
                                  <Form.Item
                                      className="view-label"
                                      label="3.แผนการเพิ่มลดการผลิตของบริษัท"
                                    >
    
                                    <Col span={24}>
                                    <Col span={24}>
                                    <Form.Item key={k} name={["add_subtract_capacity",`${k}`]}>
                                        <Flex>
                                          <Radio.Group
                                          className="custom-radio-gap"
                                          style={{ pointerEvents: "none", opacity: 1 }} 
                                          onChange={handleRadioChange('capacity' , k)} 
                                          options={options} 
                                          value={modes.capacity?.[k] ?? "0"} />
                                        </Flex>
                                      </Form.Item>
                                    </Col>
                                    </Col>
                            <Row gutter={16}>

                                    {modes.capacity?.[k] === "1" && (
                                    <Col span={8}>
                                      <Form.Item 
                                        label="แผนการเพิ่มการผลิต"
                                        
                                      >
                                          {el?.summaryVisitorExtended?.[0]?.capacity_add ?? "-"}%
                                      </Form.Item>
                                    </Col>
                                    )}
                                    {modes.capacity?.[k] === "-1" && (
                                    <Col span={8}>
                                      <Form.Item 
                                        label="แผนการลดการผลิต"
                                      >
                                        {el?.summaryVisitorExtended?.[0]?.capacity_sub ?? "-"}%

                                      </Form.Item>
                                    </Col>
                                    )}
                                    <Col span={8}>
                                      <Form.Item 
                                        label ="Product line ใหม่"
                                      >
                                        {el?.summaryVisitorExtended?.[0]?.newProductLine ?? "-"}
                                      </Form.Item>
                                    </Col>
                                </Row>

                                    </Form.Item>
                                  </Col>
                                </Row>
                              </Col>
                              <Col span={24}>
    
                                <Row gutter={16}>
                                <Col span={24}>
                                <Form.Item
                                      className="view-label"
                                      label="4.แผนเพิ่มลดการใช้ ไฟฟ้า น้ำ และ น้ำ RO ของบริษัท"
                                    >

                            <Row gutter={16}>
                                    <Col span={2}>
                                    <Form.Item
                                      className="view-label"
                                      label="4.1 ไฟฟ้า"
                                    ></Form.Item>
                                    </Col>
                                    <Col span={14}>
                                    <Form.Item 
                                      name="electricity_add/sub">
                                        <Flex vertical>
                                          <Radio.Group 
                                          style={{ pointerEvents: "none", opacity: 1 }}
                                          block onChange={handleRadioChange("electricity",k)} 
                                          options={options} 
                                          value={modes.electricity?.[k] ?? "0"} />
                                        </Flex>
                                      </Form.Item>
                                    </Col>
                                    {modes.electricity?.[k] === "1" && (
                                    <Col span={8}>
    
                                      <Form.Item 
                                        name={["electricity_add",`${k}`]}
                                        label="แผนเพิ่มการใช้ ไฟฟ้า"
    
                                        
                                      >
                                        {typeof el?.summaryVisitorExtended?.[0]?.electricity_add === "number"
                                          ? el.summaryVisitorExtended[0].electricity_add.toLocaleString()
                                          : "-"} กิโลวัตต์/เดือน

                                      </Form.Item>
                                    </Col>
                                    )}
                                    {modes.electricity?.[k] === "-1" && (
                                    <Col span={8}>
    
                                      <Form.Item 
                                        name={["electricity_sub",`${k}`]}
                                        label="แผนลดการใช้ ไฟฟ้า"
    
                                        
                                      >
                                        {typeof el?.summaryVisitorExtended?.[0]?.electricity_sub === "number"
                                          ? el.summaryVisitorExtended[0].electricity_sub.toLocaleString()
                                          : "-"} กิโลวัตต์/เดือน

                                      </Form.Item>
                                    </Col>
                                    )}
                                </Row>
                                <Row gutter={16}>
                                    <Col span={2}>
                                    <Form.Item
                                      className="view-label"
                                      label="4.2 น้ำ"
                                    ></Form.Item>
                                    </Col>

                                    <Col span={14}>
                                    <Form.Item
                                      name="water_add/sub">
                                        <Flex vertical>
                                          <Radio.Group 
                                          style={{ pointerEvents: "none", opacity: 1 }}
                                          block onChange={handleRadioChange('water',k)} 
                                          options={options} 
                                          value={modes.water?.[k] ?? "0"} />
                                        </Flex>
                                      </Form.Item>
                                    </Col>
                                    {modes.water?.[k] === "1" && (
                                    <Col span={8}>
    
                                      <Form.Item 
                                        name={["water_add",`${k}`]}
                                        label="แผนเพิ่มการใช้ น้ำ"
    
                                        
                                      >
                                        {typeof el?.summaryVisitorExtended?.[0]?.water_add === "number"
                                          ? el.summaryVisitorExtended[0].water_add.toLocaleString()
                                          : "-"} ลบ.ม./เดือน

                                      </Form.Item>
                                    </Col>
                                    )}
                                    {modes.water?.[k] === "-1" && (
                                    <Col span={8}>
    
                                      <Form.Item 
                                        name={["water_sub",`${k}`]}
                                        label="แผนลดการใช้ น้ำ"
    
                                        
                                      >
                                        {typeof el?.summaryVisitorExtended?.[0]?.water_sub === "number"
                                          ? el.summaryVisitorExtended[0].water_sub.toLocaleString()
                                          : "-"} ลบ.ม./เดือน

                                      </Form.Item>
                                    </Col>
                                    )}
                                </Row>
                                <Row gutter={16}>
                                <Col span={2}>
                                    <Form.Item
                                      className="view-label"
                                      label="4.3 น้ำ RO"

                                    ></Form.Item>
                                    </Col>

                                    <Col span={14}>
                                    <Form.Item
                                      name="ro_add/sub">
                                        <Flex vertical>
                                          <Radio.Group 
                                          style={{ pointerEvents: "none", opacity: 1 }}
                                          block onChange={handleRadioChange('ro',k)} 
                                          options={options} 
                                          value={modes.ro?.[k] ?? "0"} />
                                        </Flex>
                                      </Form.Item>
                                    </Col>
                                    {modes.ro?.[k] === "1" && (
                                    <Col span={8}>
    
                                      <Form.Item 
                                        name={["ro_add",`${k}`]}
                                        label="แผนเพิ่มการใช้ น้ำ RO"
    
                                        
                                      >
                                        {typeof el?.summaryVisitorExtended?.[0]?.ro_add === "number"
                                          ? el.summaryVisitorExtended[0].ro_add.toLocaleString()
                                          : "-"} ลบ.ม./เดือน

                                      </Form.Item>
                                    </Col>
                                    )}
                                    {modes.ro?.[k] === "-1" && (
                                    <Col span={8}>
    
                                      <Form.Item 
                                        name={["ro_sub",`${k}`]}
                                        label="แผนลดการใช้ น้ำ RO"
    
                                        
                                      >
                                        {typeof el?.summaryVisitorExtended?.[0]?.ro_sub === "number"
                                          ? el.summaryVisitorExtended[0].ro_sub.toLocaleString()
                                          : "-"} ลบ.ม./เดือน

                                      </Form.Item>
                                    </Col>
                                    )}
                                </Row>

                                    </Form.Item>
                                  </Col>
                                </Row>
                              </Col>
                              <Col span={24}>
    
                                <Row gutter={16}>
                                  <Col span={24}>
                                  <Form.Item
                                      className="view-label"
                                      label="5.บริษัทส่งออกสินค้าไปประเทศอะไร"
                                    >
                                    <Form.List name={["bigImportTo",`${k}`]}>
                                      {(fields, { add, remove }) => (
                                        <>
                                        {fields.map(({ key, name, ...restField }, k) => (
                                          <Col span ={24}>
                                          <Row gutter={16} key={key}>
                                            <Col span={8}>
                                              <Form.Item
                                              name={[name,"country_Import"]}
                                              
                                            >
                                            ประเทศ : {countries.find((item)=> 
                                                item.countryId === el?.summaryVisitorExtended?.[0]?.country_Import?.[name]
                                              )?.countryNameTh || "-"
                                              }

                                                
      
                                              </Form.Item>
                                              
                                            </Col>
                                            
                                            </Row>
                                          </Col>
                                          ))}
                                            
                                            </>
                                      )}
                                    </Form.List>
                                  </Form.Item>
                                  </Col>
                                </Row>
                                  
                                <Row gutter={16}>
                                <Col span={24}><Form.Item
                                      className="view-label"
                                      label="6.บริษัทมีการลงทุนเรื่องอุตสาหกรรมสะอาดหรือไม่ (ถ้ามีให้ระบุได้มากกว่า 1)"
                                    >
                                  <Col span={24}>
                                      <Col span={12}>
                                      <Form.Item name={["reduceCapacityPlan",`${k}`]}>
                                          <Flex>
                                            <Radio.Group
                                            className="custom-radio-gap" 
                                            style={{ pointerEvents: "none", opacity: 1 }}
                                             onChange={handleRadioLevelChange('CapacityPlan',k,'choicesReducePlan')} 
                                            options={options6} 
                                            value={modes.CapacityPlan?.[k]?.choicesReducePlan ?? "0"}/>
                                          </Flex>
                                      </Form.Item>
                                      </Col>
                                  </Col>
                                  {modes?.CapacityPlan?.[k]?.choicesReducePlan === "1" && (
                                    <Col span={24}>
                                      <Row>
                                        <Col span={24}>
                                            <Form.Item name={['isSelectReduce', `${k}`]} initialValue={modes.CapacityPlan?.[k]?.isSelectReduce || []}>
                                              <Checkbox.Group
                                              style={{ pointerEvents: "none", opacity: 1 }}
                                                onChange={(checkedValues) => {
                                                  setModes((prev) => ({
                                                    ...prev,
                                                    CapacityPlan: {
                                                      ...prev.CapacityPlan,
                                                      [k]: {
                                                        ...prev.CapacityPlan[k],
                                                        isSelectReduce: checkedValues, // อัพเดทค่าที่เลือกใน checkbox
                                                      },
                                                    },
                                                  }));
                                                }}
                                              >
                                                {planOptions.map((option, index) => (
                                                  <Col span={4} key={index}>
                                                    <Checkbox value={option}>{option}</Checkbox>
                                                  </Col>
                                                ))}
                                              </Checkbox.Group>
                                            </Form.Item>
    
                                        </Col>
                                        {form.getFieldValue(["isSelectReduce",k])?.includes("อื่นๆ") && (
                                          <Col span={8}>
                                            <Form.Item
                                            name={["otherReduce",`${k}`]}
                                            label="อื่นๆ"
                                            rules={[{ required: true, message: 'โปรดระบุ' }]}
                                            preserve={false}
                                            >
                                              {form.getFieldValue(["otherReduce", `${k}`]) || "-"}
                                            </Form.Item>
                                          </Col>
                                        )}
                                      </Row>
                                    </Col>
                                  )}
                                  {modes?.CapacityPlan?.[k]?.choicesReducePlan === "0" && (
                                    <Col span={24}>
                                      <Col span={12}>
                                        <Form.Item name={["futureCapacityPlan",`${k}`]} label="มีแผนนำพลังงานสะอาด มาใช้ในอนาคตหรือไม่ (ถ้ามีให้ระบุได้มากกว่า 1)" preserve={false}>
                                            <Flex>
                                              <Radio.Group style={{ pointerEvents: "none", opacity: 1 }}
                                              className="custom-radio-gap"
                                              onChange={handleRadioLevelChange('CapacityPlan',k,'choicesFuturePlan')} 
                                              options={options6} 
                                              value={modes.CapacityPlan?.[k]?.choicesFuturePlan ?? "0"} />
                                            </Flex>
                                        </Form.Item>
                                      </Col>
                                  </Col>
                                  ) }
                                  {modes?.CapacityPlan?.[k]?.choicesFuturePlan === "1" && (
                                    <Col span={24}>
                                    <Row>
                                    <Col span={24}>
                                      <Form.Item name={['isSelectFuture', `${k}`]} initialValue={modes.CapacityPlan?.[k]?.isSelectFuture || []}>
                                        <Checkbox.Group
                                        style={{ pointerEvents: "none", opacity: 1 }}
                                          onChange={(checkedValues) => {
                                            setModes((prev) => ({
                                              ...prev,
                                              CapacityPlan: {
                                                ...prev.CapacityPlan,
                                                [k]: {
                                                  ...prev.CapacityPlan[k],
                                                  isSelectFuture: checkedValues, // อัพเดทค่าที่เลือกใน checkbox
                                                },
                                              },
                                            }));
                                          }}
                                        >
                                          {planOptions.map((option, index) => (
                                            <Col span={4} key={index}>
                                              <Checkbox value={option}>{option}</Checkbox>
                                            </Col>
                                          ))}
                                        </Checkbox.Group>
                                      </Form.Item>
                                    </Col>
  
                                      {form.getFieldValue(["isSelectFuture",k])?.includes("อื่นๆ") && (
                                        <Col span={8}>
                                          <Form.Item
                                          name={["otherFuture",`${k}`]}
                                          label="อื่นๆ"
                                          preserve={false}
                                          >
                                            {form.getFieldValue(["otherFuture", `${k}`]) || "-"}
                                          </Form.Item>
                                        </Col>
                                      )}
                                    </Row>
                                  </Col>
                                  )}
                                  
                                  </Form.Item>
                                  </Col>
                                </Row>
                              </Col>
                              <Col span={24}>
    
                                <Row gutter={16}>
                                  <Col span={24}>
                                  <Form.Item
                                      className="view-label"
                                      label="7.บริษัทมีการติดตั้ง Solar cell หรือไม่ ถ้ามีกำลังผลิต Solar cell  เท่าไร"
                                    >
    
                                  <Col span={8}>
                                  <Form.Item 
                                        name={["solarcellCapacity",`${k}`]}
                                        
                                      >
                                          {typeof el?.summaryVisitorExtended?.[0]?.solarcellCapacity === "number"
                                          ? el.summaryVisitorExtended[0].solarcellCapacity.toLocaleString()
                                          : "-"} MVA (เมกะโวลต์แอมแปร์)
                                      </Form.Item>
                                    
                                  </Col>
                                  </Form.Item>
                                  </Col>
                                </Row>
                                  
                                
                              </Col>
                              <Col span={24}>
    
                                <Row gutter={16}>
                                  <Col span={24}>
                                  <Form.Item
                                      className="view-label"
                                      label="8.โรงงานของท่านมีปริมาณการใช้น้ำต่อเดือนเท่าไร"
                                    >
    
                                  <Col span={8}>
                                  <Form.Item 
                                        name={["waterUsage",`${k}`]}
                                        
                                      >
                                          {typeof el?.summaryVisitorExtended?.[0]?.waterUsage === "number"
                                          ? el.summaryVisitorExtended[0].waterUsage.toLocaleString()
                                          : "-"} ลบ.ม./เดือน
                                      </Form.Item>
                                    
                                  </Col>
                                  </Form.Item>
                                  </Col>
                                </Row>
                                  
                                
                              </Col>
                              <Col span={24}>
    
                                <Row gutter={16}>
                                  <Col span={24}>
                                  <Form.Item
                                      className="view-label"
                                      label="9.โรงงานของท่านมีปริมาณการใช้ไฟฟ้าต่อเดือนเท่าไร"
                                    >
    
                                  <Col span={8}>
                                  <Form.Item 
                                        name={["electricityUsage",`${k}`]}
                                        
                                      >
                                          {typeof el?.summaryVisitorExtended?.[0]?.electricityUsage === "number"
                                          ? el.summaryVisitorExtended[0].electricityUsage.toLocaleString()
                                          : "-"} KVA (กิโลโวลต์แอมแปร์)
                                            
                                      </Form.Item>
                                    
                                  </Col>
                                  </Form.Item>
                                  </Col>
                                </Row>
                                  
                                
                              </Col>
                              <Col span={24}>
    
                                <Row gutter={16}>
                                  <Col span={24}>
                                  <Form.Item
                                      className="view-label"
                                      label="10.โรงงานของท่านมีปริมาณน้ำเสียต่อเดือนเท่าไร"
                                    >
    
                                  <Col span={8}>
                                  <Form.Item 
                                        name={["wasteWaterVolume",`${k}`]}
                                        
                                      >
                                          {typeof el?.summaryVisitorExtended?.[0]?.wasteWaterVolume === "number"
                                          ? el.summaryVisitorExtended[0].wasteWaterVolume.toLocaleString()
                                          : "-"} ลบ.ม./เดือน
                                            
                                      </Form.Item>
                                    
                                  </Col>
                                  </Form.Item>
                                  </Col>
                                </Row>
                                  
                                
                              </Col>
                              <Col span={24}>
                                  <Row gutter={16}>
                                    <Col span={24}>
                                    <Form.Item
                                      className="view-label"
                                      label="11.โรงงานของท่านมีกำลังการผลิตเป็นไปตามแผนหรือไม่"
                                    >
      
                                    <Col span={24}>
                                    <Col span={24}>
                                    <Form.Item
                                        name={["capacity_plan", `${k}`]}
                                        rules={[{ required: true, message: "กรุณาเลือก" }]}
                                      >
                                        <Radio.Group
                                          className="custom-radio-gap"
                                          style={{ pointerEvents: "none", opacity: 1 }}
                                          options={[
                                            { label: "เป็นไปตามแผน", value: true },
                                            { label: "ไม่เป็นไปตามแผน", value: false },
                                          ]}
                                        />
                                      </Form.Item>
                                    </Col>
                                    </Col>
                                    </Form.Item>
                                  </Col>
                                  </Row>
                                    
                                  
                                </Col>
                                <Col span={24}>
      
                                  <Row gutter={16}>
                                    <Col span={24}>
                                    <Form.Item
                                      className="view-label"
                                      label="12.บริษัทท่านได้รับผลกระทบต่อมาตรการทางภาษีนำเข้าสินค้าของสหรัฐอเมริกาหรือไม่"
                                    >
      
                                    <Col span={24}>
                                    <Col span={24}>
                                    <Form.Item name={["importTax", `${k}`]} rules={[{ required: true, message: "กรุณาเลือก" }]}>
                                      <Radio.Group
                                        className="custom-radio-gap"
                                        style={{ pointerEvents: "none", opacity: 1 }}
                                        options={[
                                          { label: "ใช่", value: true },
                                          { label: "ไม่ใช่", value: false },
                                        ]}
                                      />
                                    </Form.Item>
                                    </Col>
                                    </Col>
                                    </Form.Item>
                                  </Col>
                                  </Row>
                                  
                                
                              </Col>
                              <Col span={24}>
    
                                <Row gutter={16}>
                                  <Col span={24}>
                                  <Form.Item
                                      className="view-label"
                                      label="13.สินค้าส่งออกของบริษัทท่านเป็นประเภทอะไรที่เข้าข่ายได้รับผลกระทบจากมาตรการทางภาษีนำเข้าสินค้าของสหรัฐอเมริกา"
                                    >
                                  <Form.List name={["TaxEffect",`${k}`]}>
                                    {(fields, { add, remove }) => (
                                      <>
                                      {fields.map(({ key, name, ...restField }, k) => (
                                        <Col span ={24}>
                                        <Row gutter={16} key={key}>
                                        <Col span={8}>
                                          <Form.Item
                                          name={[name ,"industryTaxImport"]}
                                          
                                        >
                                         ประเภทกลุ่มสินค้า : {
                                            industries.find(
                                              (item) => item.industryId === el.summaryVisitorExtended?.[0]?.industryTaxImport?.[name]
                                            )?.industryNameTh || "-"
                                          }
                                          </Form.Item>
                                          
                                        </Col>
                                        <Col span={8}>
                                          <Form.Item
                                            name={[name ,"productTaxImport"]}
                                            
                                          >
                                            ผลิตภัณฑ์สินค้า : {el.summaryVisitorExtended?.[0]?.productTaxImport?.[name] || "-"}
                                          </Form.Item>
                                        </Col>
                                        
                                        </Row>
                                              </Col>
                                        ))}
                                        
                                            </>
                                        )}
                                  </Form.List>
                                </Form.Item>
                                  </Col>
                                </Row>
                                  
                                
                              </Col>
                              <Col span={24}>
    
                                <Row gutter={16}>
                                  <Col span={24}>
                                  <Form.Item
                                      className="view-label"
                                      label="14.จากมาตรการทางภาษีการค้าของสหรัฐอเมริกา อาจส่งผลกระทบต่อการส่งออก และสร้างความท้าทายให้แข็งขัน
                                      บริษัทประเมินมูลค่าความเสียหายจากกำแพงภาษีทั้งทางตรงและทางอ้อม เป็นจำนวนเงินต่อปีประมาณเท่าไหร่"
                                    >
    
                                  <Col span={8}>
                                  <Form.Item 
                                        name={["estimatedCost",`${k}`]}
                                        
                                      >
                                          {el.summaryVisitorExtended?.[0]?.estimatedCost || "-"} ล้านบาท/ปี
                                      </Form.Item>
                                    
                                  </Col>
                                  </Form.Item>
                                  </Col>
                                </Row>
                                  
                                
                              </Col>
                              <Col span={24}>
    
                                <Row gutter={16}>
                                  <Col span={24}>
                                  <Form.Item
                                      className="view-label"
                                      label="15.อยากให้ กนอ. /รัฐบาล มีส่วนในการช่วยท่านได้อย่างไร"
                                    >
    
                                  <Col span={24}>
                                  <Form.Item 
                                        name={["remark_ieat",`${k}`]}
                                        
                                      >
                                        {el.summaryVisitorExtended?.[0]?.remark_ieat || "-"}

                                      </Form.Item>
                                    
                                  </Col>
                                  </Form.Item>
                                  </Col>
                                </Row>
                              </Col>
                            </div>

                             <div>
                              <Col span={24}>
                                <div
                                  style={{
                                    fontWeight: 600,
                                    fontSize: 30,
                                    marginTop: 20,
                                  }}
                                >
                                  มีความสนใจด้าน นวัตกรรม/SMEs เข้ามาเป็นส่วนหนึ่งใน Supply Chain
                                </div>
                              </Col>
                              <Col span={24}>
    
                                <Row gutter={16}>
                                  <Col span={24}>
                                  <Form.Item
                                      className="view-label"
                                      label="1.ปัจจุบันบริษัทของท่านมีความสนใจนวัตกรรมด้านใดบ้าง เพื่อพัฒนาระบบการจัดการภายในบริษัท"
                                    >
    
                                  <Col span={24}>
                                  <Form.Item 
                                        name={["innovationInterest",`${k}`]}
                                        
                                      >
                                        {el.summaryVisitorExtended?.[0]?.innovationInterest || "-"}

                                      </Form.Item>
                                    
                                  </Col>
                                  </Form.Item>
                                  </Col>
                                </Row>
                              </Col>
                              <Col span={24}>
    
                                <Row gutter={16}>
                                  <Col span={24}>
                                  <Form.Item
                                      className="view-label"
                                      label="2.หากมีธุรกิจ SMEs สนใจเข้ามาเป็นส่วนหนึ่งของ Supply Chain ในธุรกิจของท่าน ท่านมีความสนใจหรือไม่"
                                    >
    
                                  <Col span={24}>
                                  <Form.Item 
                                        name={["smesInterest",`${k}`]}
                                        
                                      >
                                        {el.summaryVisitorExtended?.[0]?.smesInterest || "-"}

                                      </Form.Item>
                                    
                                  </Col>
                                  </Form.Item>
                                  </Col>
                                </Row>
                              </Col>
                              <Col span={24}>
    
                                <Row gutter={16}>
                                  <Col span={24}>
                                  <Form.Item
                                      className="view-label"
                                      label="3.หากสนใจ ท่านมีความสนใจด้านใดบ้าง โปรดระบุ"
                                    >
    
                                  <Col span={24}>
                                  <Form.Item 
                                        name={["interestDetail",`${k}`]}
                                        
                                      >
                                        {el.summaryVisitorExtended?.[0]?.interestDetail || "-"}

                                      </Form.Item>
                                    
                                  </Col>
                                  </Form.Item>
                                  </Col>
                                </Row>
                              </Col>
                            </div> 
                            <Col span={24}>
                              <div
                                style={{
                                  fontWeight: 600,
                                  fontSize: 16,
                                  marginTop: 20,
                                }}
                              >
                                แผนการซื้อ/เช่าที่ดิน เพื่อประกอบอุตสาหกรรม
                              </div>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="1.ลูกค้ามีแผนการซื้อ/เช่าที่ดิน เพื่อประกอบอุตสาหกรรมในอนาคตหรือไม่"
                                className="view-label"
                              >
                                {el?.buyOrRentLand
                                  ? "มี"
                                  : !el?.buyOrRentLand
                                  ? "ไม่มี"
                                  : "ไม่ทราบ"}
                              </Form.Item>
                            </Col>

                            {el?.buyOrRentLand && (
                              <>
                                <Col span={24}>
                                  <Form.Item
                                    label="2.ลูกค้ามีแผนการซื้อ/เช่าที่ดิน เพื่อประกอบอุตสาหกรรมในพื้นที่ใด"
                                    className="view-label"
                                  >
                                    {el?.buyOrRentLandProvince || "-"}
                                  </Form.Item>
                                </Col>
                                <Col span={24}>
                                  <Form.Item
                                    label="3.ที่ดินที่ลูกค้ามีแผนการซื่อ/เช่า เพื่อใช้ในการประกอบอุตสาหกรรมใด"
                                    className="view-label"
                                  >
                                    {el?.buyOrRentLandEstate
                                      ? industries.map(
                                          (item) =>
                                            item.industryId ===
                                              el?.buyOrRentLandEstate &&
                                            item.industryNameTh
                                        )
                                      : "-"}
                                  </Form.Item>
                                </Col>
                                <Col span={24}>
                                  <Form.Item
                                    label="4.ลูกค้ามีแผนการซื่อ/เช่าที่ดิน เพื่อใช้ในการประกอบอุตสาหกรรมในปีใด"
                                    className="view-label"
                                  >
                                    {/* {el?.buyOrRentLandYear
                                      ? parseInt(el?.buyOrRentLandYear) + 543
                                      : "-"} */}
                                    {el?.buyOrRentLandYear &&
                                    el?.buyOrRentLandYear <= 10
                                      ? "ภายใน " + el?.buyOrRentLandYear + " ปี"
                                      : "มากกว่า 10 ปี"}
                                  </Form.Item>
                                </Col>
                                <Col span={24}>
                                  <Form.Item
                                    label="5.ลูกค้าต้องการพื้นที่จำนวนกี่ไร่"
                                    className="view-label"
                                  >
                                    {el?.buyOrRentLandRai
                                      ? parseFloat(
                                          el?.buyOrRentLandRai
                                        ).toFixed(2)
                                      : "-"}
                                  </Form.Item>
                                </Col>
                              </>
                            )}

                            <Col span={24}>
                              <div
                                style={{
                                  fontWeight: 600,
                                  fontSize: 16,
                                  marginTop: 20,
                                }}
                              >
                                ช่องทางการสื่อสารและการให้บริการที่ลูกค้าใช้ในการติดต่อ
                              </div>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="1. ช่องทาง Digital ที่ท่านสะดวกใช้ในการติดต่อสื่อสารกับ กนอ. คือช่องทางใด"
                                className="view-label"
                              >
                                <ul style={{ margin: 0 }}>
                                  {touchPointChannel.map((item) => {
                                    for (
                                      let index = 0;
                                      index < el?.digitalContact.length;
                                      index++
                                    ) {
                                      const element = el?.digitalContact[index];
                                      if (element === item.dataId) {
                                        return (
                                          <li key={item.vocUniqueId}>
                                            {item.dataDetailTh}
                                          </li>
                                        );
                                      }
                                    }
                                  })}

                                  {el?.digitalContact.includes("-99") && (
                                    <li>อื่นๆ</li>
                                  )}
                                </ul>
                              </Form.Item>
                              {el?.digitalContactSpecify && (
                                <Form.Item
                                  label=""
                                  style={{ marginTop: 8, marginLeft: 30 }}
                                >
                                  {el?.digitalContactSpecify || ""}
                                </Form.Item>
                              )}
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="2. ช่องทาง Physical ที่ท่านสะดวกใช้ในการติดต่อสื่อสารกับ กนอ. คือช่องทางใด"
                                className="view-label"
                              >
                                {el?.physicalContact ? (
                                  <ul>
                                    {touchPointChannelPhysical.map((item) => {
                                      for (
                                        let index = 0;
                                        index < el?.physicalContact.length;
                                        index++
                                      ) {
                                        const element =
                                          el?.physicalContact[index];
                                        if (element === item.dataId) {
                                          return (
                                            <li key={item.dataId}>
                                              {item.dataDetailTh}
                                            </li>
                                          );
                                        }
                                      }
                                    })}
                                  </ul>
                                ) : (
                                  "-"
                                )}
                              </Form.Item>
                            </Col>
                            <Col span={24}>
                              <Form.Item
                                label="3.ข้อเสนอแนะ ช่องทางการสื่อสารและการให้บริการที่ลูกค้าใช้ในการติดต่อ"
                                className="view-label"
                              >
                                {el?.contactSuggestion || "-"}
                              </Form.Item>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    ))}
                </Row>
              )}
            </Form>
          </Col>
        </Row>

        <FloatButton.BackTop
          className="custom-float-btn"
          icon={<ArrowUpOutlined style={{ color: "#fff" }} />}
          shape="square"
          style={{ backgroundColor: "#499D96 !important", color: "#fff" }}
        />
      </div>
    </WithSidebar>
  );
};
